import api from '../api'

export default {

  version: async () => {
    return api.get('/api/version')
  },
  

  getOrder: async id => {
    return api.get('/api/shopify/order-fetch/' + id)
  },

  paidSuccess: async uid => {
    return api.get('/api/shopify/order-paid-success/' + uid)
  },

  paidFailed: async uid => {
    return api.get('/api/shopify/order-paid-failed/' + uid)
  },

  fnbPrepare: async id => {
    return api.get('/api/fnb/prepare/' + id)
  },



}
